/**
 * 有效期缓存，默认24小时
 * 设置缓存版本号，后端修改数据后，前端强制刷新缓存
 * 当使用这个hook判断有效缓存时，缓存内容需要遵循指定格式
 * {
 *  timestamp: xxx, // 时间戳
 *  data: xxx // 缓存数据
 *  cache_version: 'v1'
 * }
*/

import { ref } from 'vue'
import storage from '@/utils/storage'

const time = 24 * 60 * 60 * 1000
const CACHE_VERSION = 'v2'
export const useValidCache = (cacheKey, validTime = time) => {
  const cacheData = ref(storage.get(cacheKey))

  if (cacheData.value) {
    const timestamp = cacheData.value.timestamp
    const cache_version = cacheData.value.cache_version
    if (cache_version !== CACHE_VERSION) {
      cacheData.value = null
      storage.remove(cacheKey)
      storage.remove('clickedCategories')
      storage.remove('H5ClickedCategories')
    } else if (Date.now() - timestamp > validTime) {
      storage.remove(cacheKey)
      cacheData.value = null
    }
  }

  return {
    cacheData,
    CACHE_VERSION
  }
}
